/**
 * KaiaSparkleIcon component that renders a sparkle icon with configurable color.
 * 
 * @param props - The component props
 * @param props.color - The color variant of the icon. Can be either 'gradient' (renders purple/magenta) or 'black'
 * 
 * @returns A sparkle SVG icon with different paths and dimensions based on the color prop:
 * - 'black': 28x28 icon with black fill
 * - 'gradient': 36x36 icon with purple (#C700D3) fill
 * 
 * @example
 * ```tsx
 * <KaiaSparkleIcon color="black" />
 * <KaiaSparkleIcon color="gradient" />
 * ```
 */
const KaiaSparkleIcon = ({ color }: { color: 'gradient' | 'black' }) => {
  if (color === 'black')
    return (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.2633 18.2304C17.233 19.2506 16.4901 20.551 16.0268 22.1273C15.5641 20.5583 14.826 19.2611 13.8014 18.242C12.791 17.2372 11.5197 16.5207 10 16.0749C11.5196 15.627 12.792 14.9082 13.8027 13.8995C14.8269 12.8774 15.5641 11.5759 16.0242 10C16.4862 11.5711 17.2225 12.8729 18.2469 13.8957C19.2579 14.9053 20.5317 15.6254 22.058 16.0706C20.5445 16.5158 19.2744 17.2294 18.2633 18.2304Z" fill="black" />
        <path d="M3.50127 6.12421C5.48989 5.67537 6.64286 4.26382 6.98925 1.75C7.37864 4.18928 8.47599 5.69916 10.5 6.10835C8.53036 6.57146 7.35082 7.99408 7.00316 10.5C6.64412 8.00046 5.49242 6.55243 3.5 6.12421H3.50127Z" fill="black" />
        <path d="M21.7757 10.5C21.4384 8.51208 20.6665 7.38194 19.25 7.00644C20.6308 6.59414 21.4483 5.52472 21.7585 3.5C22.0772 5.51 22.8691 6.60518 24.5 6.96595C22.9334 7.40402 22.053 8.42559 21.7757 10.4981V10.5Z" fill="black" />
      </svg>
    )

  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.988 26.4199C20.6634 27.7315 19.7082 29.4035 19.1126 31.4301C18.5176 29.4129 17.5687 27.745 16.2513 26.4348C14.9522 25.1429 13.3177 24.2216 11.3638 23.6485C13.3176 23.0726 14.9535 22.1484 16.253 20.8515C17.5698 19.5374 18.5177 17.8641 19.1092 15.8379C19.7032 17.8579 20.6499 19.5316 21.9669 20.8467C23.2668 22.1447 24.9046 23.0705 26.8669 23.643C24.921 24.2154 23.288 25.1329 21.988 26.4199Z" fill="#C700D3" />
      <path d="M4.50163 7.87398C7.05843 7.2969 8.54082 5.48206 8.98618 2.25C9.48682 5.38622 10.8977 7.32749 13.5 7.85359C10.9676 8.44902 9.45106 10.2781 9.00406 13.5C8.54244 10.2863 7.06168 8.42455 4.5 7.87398H4.50163Z" fill="#C700D3" />
      <path d="M27.9973 13.5C27.5636 10.9441 26.5712 9.49106 24.75 9.00828C26.5253 8.47818 27.5764 7.10321 27.9752 4.5C28.385 7.08428 29.4031 8.49237 31.5 8.95622C29.4858 9.51946 28.3538 10.8329 27.9973 13.4976V13.5Z" fill="#C700D3" />
    </svg>
  )
};

export default KaiaSparkleIcon;